import React from "react"

export function SectionTitle({ children }: { children: React.ReactNode }) {
  return <h2 className="bold fs-6 mb-0">{children}</h2>
}
